export const defaultMsg = 'An unexpected error occurred.';

export const appsyncError = input => {
  try {
    if (!input.errors[0].message) throw (defaultMsg)
    return input.errors[0].message;
  } catch {
    return defaultMsg;
  }
};